(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ev-gift-guide-2026"] && !Shopify.designMode) return;
  try {
    
function initEvGifts(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 
 const budgetCards=[...root.querySelectorAll('[data-budget-card]')],budgetGrid=root.querySelector('[data-budget-grid]'),budgetMore=root.querySelector('[data-budget-more]'),budgetResult=root.querySelector('[data-budget-result]');let budget=30,expanded=false;
 const drawBudget=()=>{const matches=budgetCards.filter(card=>Number(card.dataset.price)<=budget*100).sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));budgetCards.forEach(card=>card.hidden=true);matches.forEach((card,i)=>{budgetGrid.append(card);card.hidden=!expanded&&i>=4;});budgetResult.textContent=matches.length+' '+budgetResult.dataset.label+' '+budget+' €';budgetMore.hidden=matches.length<=4||expanded;};
 root.querySelectorAll('[data-gift-budget]').forEach(button=>button.addEventListener('click',()=>{budget=Number(button.dataset.giftBudget);expanded=false;root.querySelectorAll('[data-gift-budget]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));drawBudget();}));budgetMore.addEventListener('click',()=>{expanded=true;drawBudget();});drawBudget();

 const form=root.querySelector('[data-sock-form]'),submit=root.querySelector('[data-sock-submit]'),message=root.querySelector('[data-cart-message]');
 const quantities=[...root.querySelectorAll('[data-sock-quantity]')];
 const update=()=>{const count=quantities.reduce((a,s)=>a+Number(s.value),0);root.querySelector('[data-sock-count]').textContent=count+' / 4';submit.disabled=count!==4;root.querySelectorAll('[data-sock-card]').forEach(card=>{const n=Number(card.querySelector('[data-sock-quantity]').value);card.querySelector('[data-sock-value]').textContent=n;card.querySelector('[data-sock-step="-1"]').disabled=n===0;const plus=card.querySelector('[data-sock-step="1"]');plus.disabled=plus.hasAttribute('data-unavailable')||count>=4;});};
 root.querySelectorAll('[data-sock-step]').forEach(button=>button.addEventListener('click',()=>{const field=button.closest('[data-sock-card]').querySelector('[data-sock-quantity]');field.value=String(Math.max(0,Math.min(4,Number(field.value)+Number(button.dataset.sockStep))));update();}));
 quantities.forEach(s=>s.addEventListener('change',update));update();
 form.addEventListener('submit',async e=>{e.preventDefault();const items=[...form.querySelectorAll('[data-sock-card]')].map(card=>({id:Number(card.querySelector('[data-sock-variant]').value),quantity:Number(card.querySelector('[data-sock-quantity]').value)})).filter(i=>i.quantity>0);if(items.reduce((a,i)=>a+i.quantity,0)!==4){message.textContent=root.dataset.chooseFour;return;}const original=submit.textContent;submit.disabled=true;submit.textContent=root.dataset.wait;message.textContent='';try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||root.dataset.error);message.textContent=root.dataset.success;window.location.assign(window.Shopify.routes.root+'cart');}catch(err){message.textContent=err.message||root.dataset.error;submit.textContent=original;update();}});
 const share=root.querySelector('[data-gift-share]');share.addEventListener('click',async()=>{const url=new URL(window.location.href);url.search='';url.hash='';try{if(navigator.share)await navigator.share({title:document.title,url:url.href});else{await navigator.clipboard.writeText(url.href);root.querySelector('[data-share-message]').textContent=root.dataset.copied;}}catch(err){if(err.name!=='AbortError')root.querySelector('[data-share-message]').textContent=url.href;}});
}
document.querySelectorAll('[data-ev-gifts]').forEach(initEvGifts);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ev-gifts]').forEach(initEvGifts));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ev-gift-page-live-2026"] && !Shopify.designMode) return;
  try {
    
function initEvGifts(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 
 const budgetCards=[...root.querySelectorAll('[data-budget-card]')],budgetGrid=root.querySelector('[data-budget-grid]'),budgetMore=root.querySelector('[data-budget-more]'),budgetResult=root.querySelector('[data-budget-result]');let budget=30,expanded=false;
 const drawBudget=()=>{const matches=budgetCards.filter(card=>Number(card.dataset.price)<=budget*100).sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));budgetCards.forEach(card=>card.hidden=true);matches.forEach((card,i)=>{budgetGrid.append(card);card.hidden=!expanded&&i>=4;});budgetResult.textContent=matches.length+' '+budgetResult.dataset.label+' '+budget+' €';budgetMore.hidden=matches.length<=4||expanded;};
 root.querySelectorAll('[data-gift-budget]').forEach(button=>button.addEventListener('click',()=>{budget=Number(button.dataset.giftBudget);expanded=false;root.querySelectorAll('[data-gift-budget]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));drawBudget();}));budgetMore.addEventListener('click',()=>{expanded=true;drawBudget();});drawBudget();

 const form=root.querySelector('[data-sock-form]'),submit=root.querySelector('[data-sock-submit]'),message=root.querySelector('[data-cart-message]');
 const quantities=[...root.querySelectorAll('[data-sock-quantity]')];
 const update=()=>{const count=quantities.reduce((a,s)=>a+Number(s.value),0);root.querySelector('[data-sock-count]').textContent=count+' / 4';submit.disabled=count!==4;root.querySelectorAll('[data-sock-card]').forEach(card=>{const n=Number(card.querySelector('[data-sock-quantity]').value);card.querySelector('[data-sock-value]').textContent=n;card.querySelector('[data-sock-step="-1"]').disabled=n===0;const plus=card.querySelector('[data-sock-step="1"]');plus.disabled=plus.hasAttribute('data-unavailable')||count>=4;});};
 root.querySelectorAll('[data-sock-step]').forEach(button=>button.addEventListener('click',()=>{const field=button.closest('[data-sock-card]').querySelector('[data-sock-quantity]');field.value=String(Math.max(0,Math.min(4,Number(field.value)+Number(button.dataset.sockStep))));update();}));
 quantities.forEach(s=>s.addEventListener('change',update));update();
 form.addEventListener('submit',async e=>{e.preventDefault();const items=[...form.querySelectorAll('[data-sock-card]')].map(card=>({id:Number(card.querySelector('[data-sock-variant]').value),quantity:Number(card.querySelector('[data-sock-quantity]').value)})).filter(i=>i.quantity>0);if(items.reduce((a,i)=>a+i.quantity,0)!==4){message.textContent=root.dataset.chooseFour;return;}const original=submit.textContent;submit.disabled=true;submit.textContent=root.dataset.wait;message.textContent='';try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||root.dataset.error);message.textContent=root.dataset.success;window.location.assign(window.Shopify.routes.root+'cart');}catch(err){message.textContent=err.message||root.dataset.error;submit.textContent=original;update();}});
 const share=root.querySelector('[data-gift-share]');share.addEventListener('click',async()=>{const url=new URL(window.location.href);url.search='';url.hash='';try{if(navigator.share)await navigator.share({title:document.title,url:url.href});else{await navigator.clipboard.writeText(url.href);root.querySelector('[data-share-message]').textContent=root.dataset.copied;}}catch(err){if(err.name!=='AbortError')root.querySelector('[data-share-message]').textContent=url.href;}});
}
document.querySelectorAll('[data-ev-gifts]').forEach(initEvGifts);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ev-gifts]').forEach(initEvGifts));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ev-ugc-story"] && !Shopify.designMode) return;
  try {
    
  const evCalendarRequests = new Map();
  function evBindCalendarVariants() {
    if (!document.querySelector('[data-ev-ugc]')) return;
    document.querySelectorAll('variant-picker[data-template-view="adventskalender-2026"]').forEach(picker => {
      if (picker.evCalendarBound) return;
      picker.evCalendarBound = true;
      let selected = picker.selectedVariant;
      Object.defineProperty(picker, 'selectedVariant', {get: () => selected, configurable: true});
      picker.selectCombination = async function({optionValues}) {
        const formId = picker.getAttribute('form-id');
        const form = document.forms[formId];
        if (!form) return;
        evCalendarRequests.get(formId)?.abort();
        const controller = new AbortController();
        evCalendarRequests.set(formId, controller);
        const atc = document.querySelector('[data-config-atc]');
        if (atc) atc.disabled = true;
        const error = document.querySelector('[data-ev-options-error]');
        if (error) error.remove();
        try {
          const url = new URL(`${Shopify.routes.root}products/${picker.getAttribute('handle')}`, location.origin);
          url.searchParams.set('option_values', optionValues.join(','));
          url.searchParams.set('view', 'adventskalender-2026');
          const response = await fetch(url, {signal: controller.signal});
          if (!response.ok) throw new Error('Calendar options unavailable');
          let html = await response.text();
          if (controller.signal.aborted) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const incoming = parsed.querySelector('variant-picker[data-template-view="adventskalender-2026"]');
          const sourceSection = incoming?.getAttribute('section-id');
          if (!sourceSection) throw new Error('Calendar template unavailable');
          html = html.replaceAll(sourceSection, picker.getAttribute('section-id'));
          const fragment = document.createRange().createContextualFragment(html);
          const freshPicker = fragment.querySelector('variant-picker[data-template-view="adventskalender-2026"]');
          const previousVariant = selected;
          selected = JSON.parse(freshPicker.querySelector('script[data-variant]')?.textContent || '{}');
          const variantInput = form.elements.namedItem('id');
          variantInput.value = selected?.id || '';
          variantInput.dispatchEvent(new Event('change', {bubbles: true}));
          if (selected?.id && location.pathname.includes('/products/')) {
            const current = new URL(location.href);
            current.searchParams.set('variant', selected.id);
            history.replaceState(history.state, '', current);
          }
          form.dispatchEvent(new CustomEvent('product:rerender', {detail: {htmlFragment: fragment, productChange: false}}));
          evBindCalendarVariants();
          form.dispatchEvent(new CustomEvent('variant:change', {bubbles: true, detail: {formId, variant: selected, previousVariant}}));
        } catch (error) {
          if (error.name === 'AbortError') return;
          const body = document.querySelector('.advent-config-layer__body');
          if (body) {
            const notice = document.createElement('p');
            notice.dataset.evOptionsError = '';
            notice.setAttribute('role', 'alert');
            notice.textContent = 'Die Auswahl konnte nicht geladen werden. Bitte wähle deine Größe noch einmal aus.';
            body.prepend(notice);
          }
          if (atc) atc.disabled = true;
        }
      };
    });
  }
  customElements.whenDefined('variant-picker').then(evBindCalendarVariants);
  document.addEventListener('shopify:section:load', evBindCalendarVariants);

  function evUgcInit(){
    const root=document.querySelector('[data-ev-ugc]');
    if(!root)return;
    const shop=root.querySelector('[data-ev-shop]');
    const syncGeneralChoice=color=>{
      if(root.dataset.angle!=='general'||!color)return;
      const label=color.dataset.evShopColor;
      document.querySelectorAll('[data-ev-order-color]').forEach(el=>el.textContent=label);
      const setPhoto=(selector,url,alt)=>document.querySelectorAll(selector).forEach(img=>{if(img.getAttribute('src')!==url){img.removeAttribute('srcset');img.src=url;}img.alt=alt;});
      const sized=(url,width)=>{const src=new URL(url,location.href);src.searchParams.set('width',width);return src.href;};
      setPhoto('[data-ev-order-pad],.ev-ugc__product-grid article:nth-child(1) img',sized(color.dataset.evShopPhoto,780),'Schabracke in '+label);
      setPhoto('[data-ev-order-ears],.ev-ugc__product-grid article:nth-child(2) img',sized(color.dataset.evShopEars,780),'Fliegenohren in '+label);
      setPhoto('[data-ev-gallery-tab="pad"] img',sized(color.dataset.evShopPhoto,160),'Schabracke in '+label);
      document.querySelectorAll('[data-ev-color]').forEach(link=>{if(new URL(link.href).pathname===new URL(color.dataset.evShopUrl,location.origin).pathname)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
    };
    if(shop)syncGeneralChoice(shop.querySelector('[data-ev-shop-color][aria-pressed="true"]'));
    if(shop&&!shop.evShopBound){
      shop.evShopBound=true;
      const showPanel=key=>{
        shop.querySelectorAll('[data-ev-gallery-panel]').forEach(panel=>{
          panel.hidden=panel.dataset.evGalleryPanel!==key;
          if(panel.hidden)panel.querySelectorAll('video').forEach(video=>video.pause());
        });
        shop.querySelectorAll('[data-ev-gallery-tab]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.evGalleryTab===key)));
      };
      shop.addEventListener('click',event=>{
        const tab=event.target.closest('[data-ev-gallery-tab]');
        if(tab){showPanel(tab.dataset.evGalleryTab);return;}
        const color=event.target.closest('[data-ev-shop-color]');
        if(!color)return;
        shop.querySelectorAll('[data-ev-shop-color]').forEach(button=>button.setAttribute('aria-pressed',String(button===color)));
        shop.querySelectorAll('[data-ev-shop-selected]').forEach(label=>label.textContent=color.dataset.evShopColor);
        const photo=shop.querySelector('.ev-shop-pad');
        photo.removeAttribute('srcset');photo.src=color.dataset.evShopPhoto;
        photo.alt='Schabracke in '+color.dataset.evShopColor;
        showPanel('pad');
        const target=new URL(color.dataset.evShopUrl,location.origin);
        new URL(location.href).searchParams.forEach((value,key)=>{if(key.startsWith('utm_')||['gclid','fbclid','preview_theme_id','locale','ev_preview_lang','ev_locale_set'].includes(key))target.searchParams.set(key,value);});
        target.searchParams.set('ev_config','1');target.hash='ev-ugc-order';
        shop.querySelector('[data-ev-shop-buy]').href=target.href;
        root.dataset.evSelectedPurchase=target.href;
        syncGeneralChoice(color);
      });
    }

    const revealMedia=container=>{
      container.querySelectorAll('template[data-ev-deferred-media]').forEach(template=>{
        template.replaceWith(template.content.cloneNode(true));
      });
    };
    root.querySelectorAll('.ev-ugc__reveal').forEach(detail=>{
      if(detail.evMediaBound)return;
      detail.evMediaBound=true;
      detail.addEventListener('toggle',()=>{if(detail.open)revealMedia(detail);});
      if(detail.open)revealMedia(detail);
    });
    root.querySelectorAll('.ev-ugc__video').forEach(video=>{
      const playButton=video.parentElement.querySelector('[data-ev-video-play]');
      if(!playButton||video.evBound)return;
      video.evBound=true;
      playButton.addEventListener('click',()=>{video.play().catch(()=>{playButton.hidden=false;});});
      video.addEventListener('play',()=>{playButton.hidden=true;});
      video.addEventListener('ended',()=>{playButton.hidden=false;});
    });
    root.querySelectorAll('.ev-ugc__creator-reveal').forEach(detail=>{if(detail.evVideoToggle)return;detail.evVideoToggle=true;detail.addEventListener('toggle',()=>{if(!detail.open)detail.querySelectorAll('video').forEach(video=>video.pause());});});
    if(!root.evLooksBound){
      root.evLooksBound=true;
      root.addEventListener('click',event=>{
        const control=event.target.closest('[data-ev-look]');
        if(!control)return;
        const key=control.dataset.evLook;
        root.querySelectorAll('[data-ev-look-panel]').forEach(panel=>{panel.hidden=panel.dataset.evLookPanel!==key;if(!panel.hidden)revealMedia(panel);});
        root.querySelectorAll('.ev-ugc__look-swatch').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.evLook===key)));
        const panel=Array.from(root.querySelectorAll('[data-ev-look-panel]')).find(p=>p.dataset.evLookPanel===key);
        const choice=panel&&panel.querySelector('[data-ev-ugc-color]');
        if(choice){root.dataset.evSelectedPurchase=choice.href;document.querySelectorAll('[data-ev-color]').forEach(link=>{if(new URL(link.href).pathname===new URL(choice.href).pathname)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});}
        if(choice)document.querySelectorAll('a[href="#ev-ugc-order"],a[data-ev-selected-purchase]').forEach(link=>{
          link.href=choice.href;link.setAttribute('data-ev-start-config','');link.setAttribute('data-ev-selected-purchase','');
        });
        if(control.hasAttribute('data-ev-look-jump')){
          const swatch=Array.from(root.querySelectorAll('.ev-ugc__look-swatch')).find(button=>button.dataset.evLook===key);
          if(swatch)swatch.focus({preventScroll:true});
          root.querySelector('#ev-ugc-colors').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
        }
      });
    }
    const productGrid=root.querySelector('#ev-ugc-product-grid');
    if(productGrid&&!productGrid.evProductsBound){
      productGrid.evProductsBound=true;
      const items=Array.from(productGrid.children);
      const current=()=>Math.max(0,Math.min(items.length-1,Math.round(productGrid.scrollLeft/productGrid.clientWidth)));
      const update=()=>{
        const index=current();
        root.querySelectorAll('[data-ev-product-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.evProductIndex)===index)));
        root.querySelector('[data-ev-product-count]').textContent=`${index+1} / ${items.length}`;
        root.querySelector('[data-ev-product-dir="-1"]').disabled=index===0;
        root.querySelector('[data-ev-product-dir="1"]').disabled=index===items.length-1;
      };
      const go=index=>productGrid.scrollTo({left:Math.max(0,Math.min(items.length-1,index))*productGrid.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      root.querySelectorAll('[data-ev-product-index]').forEach(b=>b.addEventListener('click',()=>go(Number(b.dataset.evProductIndex))));
      root.querySelectorAll('[data-ev-product-dir]').forEach(b=>b.addEventListener('click',()=>go(current()+Number(b.dataset.evProductDir))));
      productGrid.addEventListener('keydown',event=>{if(window.matchMedia('(max-width:749px)').matches&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();go(current()+(event.key==='ArrowRight'?1:-1));}});
      productGrid.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update,{passive:true});update();
    }
    const source=new URL(window.location.href);
    if(document.documentElement.lang==='de'){document.querySelectorAll('.prose p').forEach(paragraph=>{if(paragraph.textContent.trim()==='Your favorite fashion-forward equestrian lifestyle brand — where performance meets elegance and every ride becomes a statement.')paragraph.textContent=root.dataset.footerCopy;});}
    if(source.searchParams.get('ev_preview_lang')==='de'&&(source.searchParams.get('ev_locale_set')!=='de'||document.documentElement.lang!=='de')){
      const languageForm=document.getElementById('ev-ugc-preview-language');
      const germanLink=document.querySelector('link[hreflang="de"]');
      if(languageForm&&germanLink){
        const destination=new URL(germanLink.href,window.location.origin);
        if(destination.origin===source.origin){
          destination.search=source.search;
          destination.hash=source.hash;
          destination.searchParams.set('ev_locale_set','de');
          const returnField=languageForm.querySelector('[name="return_to"]');
          if(returnField){returnField.value=destination.pathname+destination.search+destination.hash;languageForm.submit();return;}
        }
      }
    }
    document.querySelectorAll('[data-ev-ugc-color],body:has(.ev-ugc) [data-ev-color],[data-ev-shop-buy]').forEach(link=>{
      const target=new URL(link.href,window.location.origin);
      for(const [key,value] of source.searchParams){if(key.startsWith('utm_')||['locale','country','ev_preview_lang','ev_locale_set','fbclid','gclid','preview_theme_id','_ab','_fd','_sc','ev_exp','ev_experiment','ev_variant','ev_angle','ev_ad'].includes(key))target.searchParams.set(key,value);}
      if(link.hasAttribute('data-ev-start-config'))target.searchParams.set('ev_config','1');
      link.href=target.href;
    });
    if(source.searchParams.get('ev_config')==='1'&&!root.evAutoOpened){
      root.evAutoOpened=true;
      customElements.whenDefined('advent-configurator').then(()=>{
        const trigger=document.querySelector('.advent-config__trigger:not(.advent-config__trigger--floating)');
        if(trigger)trigger.click();
        const clean=new URL(window.location.href);clean.searchParams.delete('ev_config');history.replaceState(history.state,'',clean);
      });
    }
    const colorGrid=root.querySelector('.ev-ugc__color-grid');
    if(colorGrid&&!colorGrid.evBound){
      colorGrid.evBound=true;
      const updateColorControls=()=>{
        const previous=root.querySelector('[data-ev-colors-dir="-1"]');
        const next=root.querySelector('[data-ev-colors-dir="1"]');
        if(previous)previous.disabled=colorGrid.scrollLeft<=2;
        if(next)next.disabled=colorGrid.scrollLeft+colorGrid.clientWidth>=colorGrid.scrollWidth-2;
      };
      colorGrid.addEventListener('scroll',updateColorControls,{passive:true});
      window.addEventListener('resize',updateColorControls,{passive:true});
      if(window.matchMedia('(max-width:749px)').matches){
        const selected=colorGrid.querySelector('[aria-current="true"]');
        if(selected)colorGrid.scrollLeft=Array.from(colorGrid.children).indexOf(selected)*colorGrid.clientWidth;
      }
      updateColorControls();
    }
    if(window.location.hash==='#ev-ugc-exchange'){const answer=document.getElementById('ev-ugc-exchange');if(answer)answer.open=true;}
    const sticky=root.querySelector('[data-ev-ugc-sticky]');
    const order=document.querySelector('.advent-config__trigger:not(.advent-config__trigger--floating)');
    if(root.evUgcObserver)root.evUgcObserver.disconnect();
    if(sticky&&order){
      let orderVisible=false,heroVisible=false;
      root.evUgcObserver=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{if(entry.target===order)orderVisible=entry.isIntersecting;else heroVisible=entry.isIntersecting;});
        sticky.hidden=orderVisible||(root.dataset.angle==='general'&&window.matchMedia('(min-width:750px)').matches&&heroVisible);
      });
      root.evUgcObserver.observe(order);
      if(root.dataset.angle==='general'&&shop)root.evUgcObserver.observe(shop);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',evUgcInit);else evUgcInit();
  document.addEventListener('click',event=>{if(event.target.closest('a[href="#ev-ugc-exchange"]')){const answer=document.getElementById('ev-ugc-exchange');if(answer)answer.open=true;}});
  document.addEventListener('click',event=>{const control=event.target.closest('[data-ev-colors-dir]');if(control){const grid=document.querySelector('.ev-ugc__color-grid');if(grid)grid.scrollBy({left:grid.clientWidth*Number(control.dataset.evColorsDir),behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}});
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[data-ev-start-config]');
    if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const target=new URL(link.href,location.origin);
    if(target.pathname!==location.pathname)return;
    const trigger=document.querySelector('.advent-config__trigger:not(.advent-config__trigger--floating)');
    if(trigger){event.preventDefault();trigger.click();}
  });
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('.advent-config__trigger');
    const root=document.querySelector('[data-ev-ugc]');
    if(!trigger||!root||!root.dataset.evSelectedPurchase)return;
    const target=new URL(root.dataset.evSelectedPurchase,location.origin);
    if(target.pathname!==location.pathname){event.preventDefault();event.stopImmediatePropagation();location.assign(target.href);}
  },true);
  document.addEventListener('shopify:section:load',evUgcInit);
  document.addEventListener('variant:change',evUgcInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horse-bundle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('horse-bundle')) {
  customElements.define('horse-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-hb-data]').textContent);
      this.keys = Object.keys(this.data.colors);
      this.params = new URLSearchParams(location.search);
      this.color = this.keys.includes(this.params.get('farbe')) ? this.params.get('farbe') : this.keys[0];
      this.discipline = this.params.get('ausfuehrung') === 'springen' ? 'jumping' : 'dressage';
      this.padSize = 'Full';
      this.earSize = 'Full';
      this.preview = this.dataset.preview === 'true' || this.dataset.purchase !== 'true';
      this.parentCache = new Map();
      this.welcomeSizes = ['', ''];
      this.welcomeBusy = false;
      this.dialog = this.querySelector('dialog');
      this.onClick = event => {
        const paletteView = event.target.closest('[data-palette-view-choice]');
        if (paletteView) {
          this.querySelector('.hb-palette').dataset.paletteView = paletteView.dataset.paletteViewChoice;
          this.querySelectorAll('[data-palette-view-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === paletteView)));
          this.querySelector('[data-palette-announcement]').textContent = paletteView.textContent;
        }
        const paletteDiscipline = event.target.closest('[data-palette-discipline]');
        if (paletteDiscipline && this.discipline !== paletteDiscipline.dataset.paletteDiscipline) { this.discipline = paletteDiscipline.dataset.paletteDiscipline; this.render(true); }
        const color = event.target.closest('[data-color]');
        if (color) { this.color = color.dataset.color; this.render(true); }
        const gallery = event.target.closest('[data-gallery]');
        if (gallery) { this.querySelector('.hb-gallery-stage').dataset.view = gallery.dataset.gallery; this.querySelectorAll('[data-gallery]').forEach(button => button.setAttribute('aria-pressed', String(button === gallery))); }
        const zoom = event.target.closest('[data-zoom]');
        if (zoom) this.openZoom(zoom.dataset.zoom, zoom);
        if (event.target.closest('.hb-dialog-close') || event.target === this.dialog) this.dialog.close();
        if (event.target.closest('[data-add]')) this.add();
        if (event.target.closest('[data-welcome-add]')) this.addWelcome();
        const visualZoom = event.target.closest('[data-look-zoom]'); if (visualZoom) this.openVisualZoom(visualZoom);
        const outfitZoom = event.target.closest('[data-welcome-zoom]'); if (outfitZoom) this.openWelcomeZoom(outfitZoom);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-discipline-choice]')) { this.discipline = event.target.value; this.render(true); }
        if (event.target.matches('[data-welcome-option]')) { this.welcomeSizes[Number(event.target.dataset.welcomeOption)] = event.target.value; this.querySelector('[data-welcome-message]').textContent = ''; this.querySelector('[data-welcome-cart]').hidden = true; this.updateWelcome(); }
        if (event.target.matches('[data-size-choice]')) { this[event.target.dataset.sizeChoice === 'pad' ? 'padSize' : 'earSize'] = event.target.value; this.updateStatus(); }
      });
      this.dialog.addEventListener('close', () => { document.documentElement.style.overflow = this.previousOverflow || ''; this.zoomTrigger?.focus(); });
      this.render(false);
      if ('IntersectionObserver' in window) {
        this.classList.add('hb-enhanced');
        this.revealObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('hb-visible'); this.revealObserver.unobserve(entry.target); } }), { threshold: 0.08 });
        this.querySelectorAll('.hb-reveal').forEach(element => this.revealObserver.observe(element));
        this.stickyObserver = new IntersectionObserver(() => this.updateSticky(), { threshold: 0 });
        this.stickyObserver.observe(this.querySelector('.hb-main-cta'));
        this.stickyObserver.observe(this.querySelector('.hb-summary'));
        this.stickyObserver.observe(this.querySelector('.hb-match'));
      }
    }
    disconnectedCallback() { this.revealObserver?.disconnect(); this.stickyObserver?.disconnect(); this.paletteAnimations?.forEach(animation => animation.cancel()); }
    parts() { const set = this.data.colors[this.color]; return { set, pad: set.parts[this.discipline], ears: set.parts.ears }; }
    setImage(img, part) {
      const width = img.closest('.hb-summary') ? 350 : 1000;
      const url = new URL(part.image, location.origin); url.searchParams.set('width', width);
      img.src = url.href;
      img.srcset = [200, 400, 700, 1000].map(w => { const u = new URL(part.image, location.origin); u.searchParams.set('width', w); return `${u.href} ${w}w`; }).join(', ');
      img.alt = part.title;
    }
    render(updateUrl) {
      const { set, pad, ears } = this.parts();
      [this, document.documentElement].forEach(element => { element.style.setProperty('--hb-accent', set.accent); element.style.setProperty('--hb-tint', set.tint); element.style.setProperty('--hb-line', set.line); });
      this.querySelectorAll('[data-color-name]').forEach(node => node.textContent = set.name);
      this.querySelectorAll('[data-color]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === this.color)));
      this.querySelectorAll('[data-photo]').forEach(img => this.setImage(img, img.dataset.photo === 'pad' ? pad : ears));
      this.querySelectorAll('[data-discipline-photo]').forEach(img => { this.setImage(img, set.parts[img.dataset.disciplinePhoto]); img.alt = ''; });
      this.querySelectorAll('[data-discipline]').forEach(node => node.textContent = this.data.text[this.discipline]);
      this.querySelectorAll('[data-discipline-choice]').forEach(input => input.checked = input.value === this.discipline);
      [['pad', pad, 'padSize'], ['ears', ears, 'earSize']].forEach(([part, product, state]) => {
        const sizes = product.variants.map(v => v.size).filter(size => size !== 'Pony' || set.pony);
        const preferred = ['Full', 'Cob', 'Pony'].filter(size => sizes.includes(size));
        if (!preferred.includes(this[state])) this[state] = preferred[0];
        const group = this.querySelector(`[data-size-options=${part}]`);
        group.replaceChildren(...preferred.map(size => {
          const label = document.createElement('label'); label.className = 'hb-size-card';
          const input = document.createElement('input'); input.type = 'radio'; input.name = `hb-${part}-${this.id || this.closest('[id]')?.id || 'set'}`; input.value = size; input.dataset.sizeChoice = part; input.checked = size === this[state];
          const face = document.createElement('span'); face.textContent = size; label.append(input, face); return label;
        }));
      });
      this.renderVisuals();
      this.renderPalette(updateUrl);
      this.renderWelcome();
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('farbe', this.color); url.searchParams.set('ausfuehrung', this.discipline === 'dressage' ? 'dressur' : 'springen'); history.replaceState(null, '', url); }
      this.updateStatus();
    }
    renderPalette(animate = false) {
      const { set, pad, ears } = this.parts();
      const selected = this.querySelector(`.hb-palette-card[data-color="${this.color}"]`);
      if (!selected) return;
      this.querySelector('[data-palette-selected-mood]').textContent = selected.dataset.paletteMood;
      this.querySelectorAll('[data-palette-discipline]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.paletteDiscipline === this.discipline)));
      this.querySelectorAll('[data-palette-result-image]').forEach(img => { this.setImage(img, img.dataset.paletteResultImage === 'pad' ? pad : ears); img.alt = ''; });
      const sizes = product => ['Full', 'Cob', 'Pony'].filter(size => product.variants.some(v => v.size === size) && (size !== 'Pony' || set.pony)).join(' / ');
      this.querySelector('[data-palette-size-line]').textContent = `${this.data.text.palette_sizes} · ${this.data.text[this.discipline]}: ${sizes(pad)} · ${this.data.text.selection_ears}: ${sizes(ears)}`;
      this.querySelector('[data-palette-configure]').setAttribute('aria-label', `${this.data.text.palette_configure}: ${set.name}, ${this.data.text[this.discipline]}`);
      if (animate) this.querySelector('[data-palette-announcement]').textContent = `${this.data.text.palette_selection_status} ${set.name}. ${selected.dataset.paletteMood} ${this.data.text[this.discipline]}.`;
      this.paletteAnimations?.forEach(animation => animation.cancel());
      this.paletteAnimations = [];
      if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.paletteAnimations.push(this.querySelector('.hb-palette-result-look').animate([{ opacity: .5, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' }));
        if (this.lastPaletteColor !== this.color) this.paletteAnimations.push(selected.querySelector('.hb-palette-pictures').animate([{ transform: 'scale(.965)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' }));
      }
      this.lastPaletteColor = this.color;
    }
    updateStatus() {
      const { pad, ears } = this.parts();
      const p = pad.variants.find(v => v.size === this.padSize); const e = ears.variants.find(v => v.size === this.earSize);
      this.inStock = Boolean(p?.available && e?.available && p.stock > 0 && e.stock > 0);
      this.querySelector('[data-selection]').textContent = `${this.data.text[this.discipline]} · ${this.padSize} / ${this.earSize}`;
      this.querySelector('[data-selection-discipline]').textContent = this.data.text[this.discipline];
      this.querySelector('[data-selection-pad]').textContent = this.padSize; this.querySelector('[data-selection-ears]').textContent = this.earSize;
      const stock = this.querySelector('[data-stock]'); stock.textContent = this.data.text[this.inStock ? 'stock_ok' : 'stock_out']; stock.dataset.available = String(this.inStock);
      const button = this.querySelector('[data-add]'); button.disabled = this.preview || !this.inStock; button.textContent = this.data.text[this.preview ? 'preview_button' : this.inStock ? 'add' : 'stock_changed'];
      this.querySelector('[data-status]').textContent = this.preview ? this.data.text.draft_note : '';
    }
    updateSticky() { const hero = this.querySelector('.hb-main-cta').getBoundingClientRect(); const summary = this.querySelector('.hb-summary').getBoundingClientRect(); const match = this.querySelector('.hb-match').getBoundingClientRect(); this.querySelector('[data-sticky]').hidden = (match.top < innerHeight && match.bottom > 0) || (hero.top < innerHeight && hero.bottom > 0) || (summary.top < innerHeight && summary.bottom > 0); }
    openZoom(part, trigger) { const p = this.parts()[part]; this.zoomTrigger = trigger; this.dialog.querySelector('img').src = p.zoom; this.dialog.querySelector('img').alt = p.title; this.querySelector('[data-zoom-caption]').textContent = p.title; this.previousOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; this.dialog.showModal(); }

    money(value) { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(value / 100); }
    renderVisuals() {
      const set = this.data.colors[this.color];
      this.querySelectorAll('[data-look-photo]').forEach(image => {
        const kind = image.dataset.lookPhoto;
        const url = new URL(set.visuals[kind], location.origin);
        image.src = url.href;
        image.srcset = [350, 700, 1100].map(width => { const src = new URL(url); src.searchParams.set('width', width); return `${src.href} ${width}w`; }).join(', ');
        image.alt = kind === 'detail' ? this.data.text.visual_detail_alt + ' · ' + set.name : set.parts.ears.title;
        if (kind === 'ears') image.closest('[data-look-mode]').dataset.lookMode = set.visuals.earsLifestyle ? 'lifestyle' : 'product';
      });
      this.querySelector('[data-look-ears-label]').textContent = this.data.text[set.visuals.earsLifestyle ? 'visual_ears_worn' : 'visual_ears_tag'];
      this.querySelectorAll('[data-palette-pad]').forEach(image => {
        const part = this.data.colors[image.dataset.palettePad].parts[this.discipline];
        const url = new URL(part.image, location.origin); url.searchParams.set('width', 450); image.src = url.href;
        image.srcset = [200, 300, 450].map(width => { const src = new URL(url); src.searchParams.set('width', width); return `${src.href} ${width}w`; }).join(', ');
      });
    }
    openVisualZoom(trigger) {
      const photo = trigger.querySelector('img');
      this.zoomTrigger = trigger; this.dialog.querySelector('img').src = photo.src; this.dialog.querySelector('img').alt = photo.alt;
      this.querySelector('[data-zoom-caption]').textContent = photo.alt;
      this.previousOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; this.dialog.showModal();
    }
    renderWelcome() {
      const outfit = this.data.colors[this.color].welcome;
      const exists = Boolean(outfit && outfit.variants?.length && outfit.options?.length === 2);
      this.querySelector('[data-welcome-content]').hidden = !exists;
      this.querySelector('[data-welcome-missing]').hidden = exists;
      this.querySelector('[data-welcome-message]').textContent = '';
      this.querySelector('[data-welcome-cart]').hidden = true;
      if (!exists) return;
      const image = this.querySelector('[data-welcome-photo]');
      this.setImage(image, { image: outfit.image, title: outfit.imageAlt || outfit.title });
      this.querySelector('[data-welcome-caption]').textContent = this.data.text[this.color === 'very-berry' ? 'match_image_note_berry' : 'match_image_note'];
      this.querySelector('[data-welcome-fixed]').textContent = this.data.text[this.color === 'very-berry' ? 'match_fixed_berry' : 'match_fixed'];
      outfit.options.forEach((sizes, index) => {
        const allowed = sizes.filter(size => ['XXS','XS','S','M','L','XL'].includes(size));
        const selectable = size => outfit.pending || outfit.variants.some(v => v.options[index] === size && v.available);
        if (!allowed.includes(this.welcomeSizes[index]) || !selectable(this.welcomeSizes[index])) this.welcomeSizes[index] = '';
        this.querySelector(`[data-welcome-options="${index}"]`).replaceChildren(...allowed.map(size => {
          const label = document.createElement('label'); label.className = 'hb-size-card';
          const input = document.createElement('input'); input.type = 'radio'; input.name = `hb-welcome-${index}-${this.closest('[id]')?.id || 'set'}`; input.value = size; input.dataset.welcomeOption = String(index); input.checked = size === this.welcomeSizes[index]; input.disabled = !selectable(size);
          if (input.disabled) label.title = this.data.text.match_unavailable_size;
          const span = document.createElement('span'); span.textContent = size; label.append(input, span); return label;
        }));
      });
      this.updateWelcome();
    }
    welcomeVariant() { return this.data.colors[this.color].welcome?.variants.find(v => v.options[0] === this.welcomeSizes[0] && v.options[1] === this.welcomeSizes[1]); }
    updateWelcome() {
      const outfit = this.data.colors[this.color].welcome;
      if (!outfit) return;
      const chosen = this.welcomeVariant(); const priced = chosen || outfit.variants[0];
      const saving = priced.compare > priced.price ? Math.round((priced.compare - priced.price) / priced.compare * 100) : 0;
      this.querySelector('[data-welcome-price]').textContent = this.money(priced.price);
      this.querySelector('[data-welcome-compare]').textContent = this.money(priced.compare);
      this.querySelector('[data-welcome-offer]').hidden = !saving;
      this.querySelector('[data-welcome-percent]').textContent = '−' + saving;
      this.querySelector('[data-welcome-badge]').setAttribute('aria-label', saving + ' % ' + this.data.text.match_savings);
      this.querySelector('[data-match-total]').textContent = this.money(8995 + priced.price);
      this.querySelector('[data-welcome-selection]').textContent = chosen ? `${this.data.text.match_selection} ${this.data.colors[this.color].name} · ${this.data.text.match_selection_leggings} ${this.welcomeSizes[0]} / ${this.data.text.match_selection_zip} ${this.welcomeSizes[1]}` : this.data.text.match_choose_sizes;
      const stock = this.querySelector('[data-welcome-stock]');
      stock.textContent = outfit.pending ? this.data.text.match_pending : chosen ? this.data.text[chosen.available ? 'match_in_stock' : 'match_out_stock'] : '';
      stock.dataset.available = String(Boolean(chosen?.available && !outfit.pending));
      const button = this.querySelector('[data-welcome-add]');
      button.disabled = this.preview || outfit.pending || !chosen?.available || this.welcomeBusy;
      button.textContent = this.welcomeBusy ? this.data.text.match_loading : outfit.pending ? this.data.text.match_pending_button : !chosen ? this.data.text.match_choose_sizes : this.preview ? this.data.text.match_preview : chosen.available ? this.data.text.match_add : this.data.text.stock_changed;
      this.querySelector('[data-welcome-draft]').textContent = this.preview ? this.data.text.match_draft : '';
    }
    openWelcomeZoom(trigger) {
      const outfit = this.data.colors[this.color].welcome; if (!outfit?.image) return;
      this.zoomTrigger = trigger; this.dialog.querySelector('img').src = outfit.image; this.dialog.querySelector('img').alt = outfit.imageAlt || outfit.title;
      this.querySelector('[data-zoom-caption]').textContent = outfit.imageAlt || outfit.title;
      this.previousOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; this.dialog.showModal();
    }
    async addWelcome() {
      const outfit = this.data.colors[this.color].welcome; const chosen = this.welcomeVariant();
      if (this.preview || outfit?.pending || !chosen?.available || this.welcomeBusy) return;
      const selection = [...this.welcomeSizes]; const name = outfit.title; const color = this.color;
      this.welcomeBusy = true; this.updateWelcome();
      const message = this.querySelector('[data-welcome-message]'); message.textContent = '';
      try {
        const response = await fetch(this.dataset.root + 'products/' + encodeURIComponent(outfit.handle) + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(this.data.text.not_live);
        const product = await response.json(); const variant = product.variants.find(v => v.id === chosen.id && v.options[0] === selection[0] && v.options[1] === selection[1]);
        if (!variant?.available) throw new Error(this.data.text.match_out_stock);
        const added = await fetch(this.dataset.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) });
        if (!added.ok) throw new Error(this.data.text.error);
        if (this.color === color) { message.textContent = `${this.data.text.match_added} ${name} · ${selection[0]} / ${selection[1]}`; this.querySelector('[data-welcome-cart]').hidden = false; }
        try {
          const cartResponse = await fetch(this.dataset.root + 'cart.js', { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) { const cart = await cartResponse.json(); const link = document.querySelector('.hb-header-links a:last-child'); if (link) { link.querySelector('span').textContent = cart.item_count; link.setAttribute('aria-label', this.data.text.match_cart + ' (' + cart.item_count + ')'); } }
        } catch (_) { /* The item was added; a cart-count refresh must not invite a duplicate retry. */ }
      } catch (error) { if (this.color === color) message.textContent = error.message || this.data.text.error; }
      finally { this.welcomeBusy = false; this.updateWelcome(); }
    }

    async add() {
      if (this.preview || !this.inStock || this.busy) return;
      this.busy = true; const button = this.querySelector('[data-add]'); const status = this.querySelector('[data-status]'); button.disabled = true; button.textContent = this.data.text.loading;
      try {
        const set = this.data.colors[this.color];
        const response = await fetch(this.dataset.root + 'products/' + encodeURIComponent(set.handle) + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(this.data.text.not_live);
        const product = await response.json();
        const variant = product.variants.find(v => v.options[0] === (this.discipline === 'dressage' ? 'Dressur' : 'Springen') && v.options[1] === this.padSize && v.options[2] === this.earSize);
        if (!variant?.available) throw new Error(this.data.text.stock_changed);
        const result = await fetch(this.dataset.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) });
        if (!result.ok) throw new Error(this.data.text.error);
        location.assign(this.dataset.root + 'cart');
      } catch (error) { status.textContent = error.message || this.data.text.error; button.disabled = false; button.textContent = this.data.text.add; }
      finally { this.busy = false; }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stable-mates"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-sm-data]').textContent);
    if (!data.colors.length) return;
    let current = data.colors[0];
    let busy = false;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:data.currency}).format(cents/100);
    const tabs = [...root.querySelectorAll('[data-view]')];
    const changeView = (view, focus=false) => {
      const tab=tabs.find(el=>el.dataset.view===view);
      if(!tab) return;
      tabs.forEach(el=>{const active=el===tab;el.setAttribute('aria-selected',String(active));el.tabIndex=active?0:-1;});
      root.querySelectorAll('[data-panel]').forEach(el=>el.hidden=el.dataset.panel!==view);
      if(focus) tab.focus({preventScroll:true});
    };
    tabs.forEach((tab,i)=>{
      tab.addEventListener('click',()=>changeView(tab.dataset.view));
      tab.addEventListener('keydown',e=>{
        const next={ArrowRight:(i+1)%tabs.length,ArrowLeft:(i-1+tabs.length)%tabs.length,Home:0,End:tabs.length-1}[e.key];
        if(next!==undefined){e.preventDefault();changeView(tabs[next].dataset.view,true);}
      });
    });
    root.querySelectorAll('[data-discover]').forEach(el=>el.addEventListener('click',()=>changeView(el.dataset.discover,true)));
    const dialog=root.querySelector('.sm-lightbox');
    let opener;
    root.querySelectorAll('[data-zoom]').forEach(button=>button.addEventListener('click',()=>{
      const source=button.querySelector('img');
      const target=dialog.querySelector('img');
      const url=new URL(source.currentSrc||source.src,location.origin);
      url.searchParams.set('width','1800');
      target.src=url.href;target.alt=source.alt;
      dialog.querySelector('p').textContent=source.alt;
      opener=button;dialog.showModal();document.documentElement.style.overflow='hidden';
    }));
    root.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    dialog.addEventListener('close',()=>{document.documentElement.style.overflow='';opener?.focus({preventScroll:true});});
    const form=root.querySelector('[data-config-form]');
    const add=root.querySelector('[data-add]');
    const state=root.querySelector('[data-selection-state]');
    const error=root.querySelector('[data-error]');
    const selected=()=>{
      const belt=current.belt.variants.find(v=>String(v.id)===form.querySelector('input[name="belt"]:checked')?.value);
      const collar=current.collar.variants.find(v=>String(v.id)===form.querySelector('input[name="collar"]:checked')?.value);
      const parent=belt&&collar?current.parents.find(v=>v.option1===belt.title&&v.option2===collar.title):null;
      return {belt,collar,parent};
    };
    const stocked=color=>color.belt.variants.some(v=>v.available)&&color.collar.variants.some(v=>v.available)&&color.key.variants.some(v=>v.available);
    const update=()=>{
      const {belt,collar,parent}=selected();
      const count=Number(!!belt)+Number(!!collar);
      root.querySelector('[data-progress-text]').textContent=data.strings.progress.replace('__COUNT__',count);
      root.querySelector('[data-progress-bar]').style.width=`${count*50}%`;
      root.querySelector('[data-summary-belt]').textContent=belt?.title||data.strings.selectBelt;
      root.querySelector('[data-summary-collar]').textContent=collar?collar.title.replace(/-/g,'–').replace('cm)',' cm)'):data.strings.selectCollar;
      const componentsAvailable=belt?.available&&collar?.available&&current.key.variants.some(v=>v.available);
      const available=componentsAvailable&&(!data.enabled||parent?.available);
      state.textContent=!stocked(current)?data.strings.colorUnavailable:count<2?(count===1?data.strings.pendingOne:data.strings.pendingTwo):available?data.strings.ready:data.strings.unavailable;
      add.disabled=busy||!data.enabled||!parent?.available||!componentsAvailable;
      add.textContent=busy?data.strings.adding:!data.enabled?data.strings.preview:count<2?data.strings.choose:available?data.strings.add:data.strings.unavailable;
      error.hidden=true;
    };
    const renderOptions=(kind,previous)=>{
      const container=root.querySelector(`.sm-${kind}-options`);
      const nodes=current[kind].variants.map(variant=>{
        const label=document.createElement('label');label.className='sm-option';
        const input=document.createElement('input');input.type='radio';input.name=kind;input.value=variant.id;input.dataset.size=variant.title;input.disabled=!variant.available;input.checked=variant.available&&variant.title===previous;
        const span=document.createElement('span');
        if(kind==='collar'){
          const strong=document.createElement('strong');strong.textContent=variant.title.charAt(0);
          const small=document.createElement('small');small.textContent=variant.title.replace(/^[SML]\s*\(|\)$/g,'').replace('-','–').replace('cm',' cm');
          span.append(strong,small);
        }else span.textContent=variant.title;
        if(!variant.available){const small=document.createElement('small');small.textContent=data.strings.soldOut;span.append(small);}
        label.append(input,span);return label;
      });
      container.replaceChildren(...nodes);
    };
    const setImage=(img,src,alt)=>{
      if(!img||!src)return;
      const imageUrl=width=>{const url=new URL(src,location.origin);url.searchParams.set('width',String(width));return url.href;};
      img.srcset=[300,500,700,900,1200].map(width=>`${imageUrl(width)} ${width}w`).join(', ');
      img.src=imageUrl(1200);img.alt=alt;
      const zoom=img.closest('[data-zoom]');if(zoom)zoom.setAttribute('aria-label',`${data.strings.zoom}: ${alt}`);
    };
    const changeColor=(key,writeUrl=true,animate=true)=>{
      if(busy)return;
      const next=data.colors.find(c=>c.colorKey===key)||data.colors[0];key=next.colorKey;
      const before=selected();current=next;
      root.dataset.color=next.colorKey;
      for(const el of [root,document.documentElement]){el.style.setProperty('--sm-accent',next.accent);el.style.setProperty('--sm-paper',next.tint);el.style.setProperty('--sm-tint',next.tint);el.style.setProperty('--sm-line',next.line);}
      root.querySelectorAll('[data-color]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.color===key)));
      root.querySelectorAll('[data-color-name]').forEach(el=>el.textContent=next.name);
      root.querySelectorAll('[data-color-stock]').forEach(el=>{el.textContent=stocked(next)?data.strings.colorHint:data.strings.colorUnavailable;el.dataset.unavailable=String(!stocked(next));});
      ['belt','collar','key'].forEach((kind,i)=>{
        const product=next[kind];
        const alt=product.title+' · étalon vert';
        root.querySelectorAll(`[data-discover="${kind}"] img,[data-panel="${kind}"] img,.sm-set-images img:nth-child(${i+1})`).forEach(img=>setImage(img,product.image,alt));
        root.querySelectorAll(`[data-item-price="${kind}"]`).forEach(el=>el.textContent=money(product.price));
      });
      setImage(root.querySelector('.sm-person img'),next.hero,next.belt.title+' · étalon vert');
      root.querySelector('.sm-person').classList.toggle('sm-product-hero',!next.lifestyle);
      setImage(root.querySelector('.sm-dog img'),next.dog,data.strings.dogAlt.replace('__COLOR__',next.name));
      setImage(root.querySelector('.sm-story-photo img'),next.dog,data.strings.dogAlt.replace('__COLOR__',next.name));
      root.querySelector('[data-belt-spec]').textContent=data.strings.beltSpec.replace('__WIDTH__',next.width).replace('__SIZES__',next.belt.variants.map(v=>v.title.replace(' cm','')).join(' / '));
      root.querySelectorAll('[data-bundle-price]').forEach(el=>el.textContent=money(next.price));
      const compare=next.belt.price+next.collar.price+next.key.price;
      root.querySelectorAll('.sm-compare s').forEach(el=>el.textContent=money(compare));
      const percent=Math.round((compare-next.price)*100/compare);
      root.querySelectorAll('.sm-badge').forEach(el=>{el.firstChild.textContent=`−${percent}`;el.setAttribute('aria-label',data.strings.savings.replace('__PERCENT__',percent));});
      renderOptions('belt',before.belt?.title);renderOptions('collar',before.collar?.title);update();
      if(writeUrl){const url=new URL(location.href);url.searchParams.set('farbe',key);history.replaceState(null,'',url);}
      if(animate&&!reduced){root.querySelectorAll('.sm-hero-visual,.sm-overview,.sm-set-images').forEach(el=>el.animate([{opacity:.55,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,easing:'ease-out'}));}
    };
    root.querySelectorAll('[data-color]').forEach(button=>button.addEventListener('click',()=>changeColor(button.dataset.color)));
    form.addEventListener('change',update);
    form.addEventListener('submit',async e=>{
      e.preventDefault();const {belt,collar,parent}=selected();
      if(busy||!data.enabled||!parent?.available||!belt?.available||!collar?.available||!current.key.variants.some(v=>v.available)||add.disabled)return;
      const chosen=current;busy=true;update();
      const route=window.Shopify?.routes?.root||'/';
      try{
        const response=await fetch(`${route}products/${chosen.bundleHandle}.js`,{credentials:'same-origin'});
        if(!response.ok)throw new Error(data.strings.error);
        const product=await response.json();const fresh=product.variants.find(v=>v.id===parent.id);
        if(!fresh?.available||fresh.price!==chosen.price)throw new Error(data.strings.changed);
        const cart=await fetch(`${route}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:parent.id,quantity:1}]})});
        if(!cart.ok)throw new Error(data.strings.error);
        window.location.assign(`${route}cart`);
      }catch(err){busy=false;update();error.textContent=err.message||data.strings.error;error.hidden=false;}
    });
    changeColor(new URL(location.href).searchParams.get('farbe')||current.colorKey,false,false);
    window.addEventListener('popstate',()=>changeColor(new URL(location.href).searchParams.get('farbe')||data.colors[0].colorKey,false));
    if('IntersectionObserver' in window){const sticky=root.querySelector('.sm-sticky');const observer=new IntersectionObserver(entries=>sticky.style.visibility=entries[0].isIntersecting?'hidden':'visible',{threshold:.08});observer.observe(root.querySelector('#sm-config'));}
  };
  document.querySelectorAll('[data-stable-mates]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-stable-mates]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('welcome-bundle')) customElements.define('welcome-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-bundle-data]').textContent);
      this.t = this.data.text;
      this.color = Object.keys(this.data.colors)[0];
      this.selection = {leggings: null, zip: null};
      this.form = this.querySelector('form');
      this.add = this.querySelector('.wb-add');
      this.message = this.querySelector('[data-message]');
      this.cartButton = this.querySelector('.wb-cart-secondary');
      this.addEventListener('change', event => {
        const input = event.target;
        if (input.name === 'wb-color' || input.name === 'wb-config-color') this.setColor(input.value, true);
        else if (input.name in this.selection) { this.selection[input.name] = input.value; this.render(); }
      });
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submit(event.submitter?.value === 'cart' ? 'cart' : 'checkout'); });
      this.imageDialog = this.querySelector('.wb-image-dialog');
      this.addEventListener('click', event => {
        const viewButton = event.target.closest('[data-gallery-view]');
        if (viewButton) {
          const view = viewButton.dataset.galleryView;
          this.querySelectorAll('[data-bundle-view]').forEach(el => { el.hidden = el.dataset.bundleView !== view; });
          this.querySelectorAll('[data-gallery-view]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.galleryView === view)));
          return;
        }
        const trigger = event.target.closest('[data-zoom-part],[data-zoom-model]');
        const faqLink = event.target.closest('[data-open-faq]');
        if (trigger) this.openImage(trigger);
        else if (event.target.closest('[data-zoom-toggle]')) this.toggleImageZoom();
        else if (event.target.closest('[data-zoom-close]') || event.target === this.imageDialog) this.imageDialog.close();
        else if (faqLink) this.querySelector('#' + faqLink.dataset.openFaq).open = true;
      });
      this.imageDialog.addEventListener('close', () => this.zoomTrigger?.focus({preventScroll:true}));
      this.onPop = () => this.setColor(new URL(location.href).searchParams.get('farbe') || Object.keys(this.data.colors)[0], false);
      window.addEventListener('popstate', this.onPop);
      this.onPop();
      this.setupMotion();
      this.visibleActions = new Set();
      this.stickyObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.visibleActions.add(entry.target);
          else this.visibleActions.delete(entry.target);
        });
        const sticky = this.querySelector('.wb-sticky');
        const wasHidden = sticky.hidden;
        sticky.hidden = this.visibleActions.size > 0;
        if (wasHidden && !sticky.hidden) this.animateIn(sticky, 0, 10, 240);
      });
      [this.form, ...this.querySelectorAll('a.wb-button[href="#wb-configurator"]')].filter(target => !target.closest('.wb-sticky')).forEach(target => this.stickyObserver.observe(target));
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPop);
      this.stickyObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.motionPreference?.removeEventListener('change', this.onMotionChange);
      this.motionAnimations?.forEach(animation => animation.cancel());
      this.colorTransition?.skipTransition();
      this.visualRequest = (this.visualRequest || 0) + 1;
      document.documentElement.classList.remove('wb-color-transition');
    }
    setupMotion() {
      this.motionAnimations = new Set();
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        this.motionAllowed = !this.motionPreference.matches;
        this.dataset.motion = this.motionAllowed ? 'on' : 'off';
        if (!this.motionAllowed) {
          this.motionAnimations.forEach(animation => animation.cancel());
          this.colorTransition?.skipTransition();
          this.revealObserver?.disconnect();
        }
      };
      this.motionPreference.addEventListener('change', this.onMotionChange);
      this.onMotionChange();
      if (this.motionAllowed && 'IntersectionObserver' in window) {
        this.revealObserver = new IntersectionObserver(entries => {
          entries.filter(entry => entry.isIntersecting).forEach((entry, index) => {
            this.revealObserver.unobserve(entry.target);
            entry.target.dataset.wbReveal = 'seen';
            this.animateIn(entry.target, Math.min(index, 3) * 55);
          });
        }, {threshold:0.08});
        this.querySelectorAll('.wb-problem>*,.wb-answer-copy,.wb-answer-photo,.wb-section-heading,.wb-product-card,.wb-review .wb-wrap,.wb-config-intro,.wb-faq>h2,.wb-last-call>h2').forEach(target => {
          target.dataset.wbReveal = 'pending';
          this.revealObserver.observe(target);
        });
      }
      this.addEventListener('toggle', event => {
        if (event.target instanceof HTMLDetailsElement && event.target.open) {
          const content = event.target.querySelector('p');
          if (content) this.animateIn(content, 0, 5, 240);
        }
      }, true);
    }
    animateIn(target, delay = 0, distance = 14, duration = 520) {
      if (!this.motionAllowed || !target?.animate) return;
      const rect = target.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      const animation = target.animate([{opacity:0,transform:`translateY(${distance}px)`},{opacity:1,transform:'translateY(0)'}], {duration,delay,easing:'cubic-bezier(.22,.68,.2,1)',fill:'backwards'});
      this.motionAnimations.add(animation);
      animation.finished.catch(() => {}).then(() => this.motionAnimations.delete(animation));
    }
    setColor(key, changeUrl) {
      if (!this.data.colors[key]) key = Object.keys(this.data.colors)[0];
      const changed = this.color !== key;
      this.color = key;
      this.dataset.color = key;
      const color = this.data.colors[key];
      this.querySelectorAll('[data-color-name]').forEach(el => { el.textContent = color.name; });
      this.querySelectorAll('[name="wb-color"],[name="wb-config-color"]').forEach(el => { el.checked = el.value === key; });
      if (changeUrl) { const url = new URL(location.href); url.searchParams.set('farbe', key); history.pushState({}, '', url); }
      this.render();
      const request = this.visualRequest = (this.visualRequest || 0) + 1;
      this.colorTransition?.skipTransition();
      const update = () => { if (request === this.visualRequest) this.updateVisuals(key); };
      if (changed && changeUrl && this.motionAllowed && typeof document.startViewTransition === 'function') {
        document.documentElement.classList.add('wb-color-transition');
        try {
          const transition = this.colorTransition = document.startViewTransition(update);
          transition.ready.catch(() => {});
          transition.finished.catch(() => {}).then(() => {
            if (this.colorTransition === transition) {
              document.documentElement.classList.remove('wb-color-transition');
              this.colorTransition = null;
            }
          });
        } catch {
          document.documentElement.classList.remove('wb-color-transition');
          update();
        }
      } else {
        document.documentElement.classList.remove('wb-color-transition');
        update();
        if (changed && changeUrl) this.querySelectorAll('.wb-gallery:not([hidden]),.wb-answer-photo,.wb-product-photo').forEach(target => this.animateIn(target, 0, 4, 300));
      }
    }
    updateVisuals(key) {
      const color = this.data.colors[key];
      this.querySelectorAll('[data-gallery]').forEach(el => { el.hidden = el.dataset.gallery !== key; });
      const selectedPhoto = this.querySelector(`[data-gallery="${key}"] [data-bundle-view="set"] img`);
      const storyPhoto = this.querySelector('.wb-answer-photo img');
      if (selectedPhoto && storyPhoto) {
        storyPhoto.src = selectedPhoto.src;
        const photoSrcset = selectedPhoto.getAttribute('srcset');
        if (photoSrcset) storyPhoto.setAttribute('srcset', photoSrcset);
        else storyPhoto.removeAttribute('srcset');
        storyPhoto.alt = selectedPhoto.alt;
        const storyNote = this.querySelector('[data-story-image-note]');
        if (storyNote) storyNote.hidden = selectedPhoto.closest('[data-gallery]').dataset.aiWinter !== 'true';
      }
      this.querySelectorAll('[data-part-image]').forEach(img => { const part = color.parts[img.dataset.partImage]; img.src = part.image; img.removeAttribute('srcset'); img.alt = part.title; });
    }
    openImage(trigger) {
      const colorKey = trigger.closest('[data-gallery]')?.dataset.gallery || this.color;
      const part = trigger.hasAttribute('data-zoom-model') ? {title:trigger.querySelector('img').alt,zoom_image:trigger.dataset.zoomSrc} : this.data.colors[colorKey].parts[trigger.dataset.zoomPart];
      if (!part) return;
      const img = this.imageDialog.querySelector('[data-zoom-image]');
      const zoomRequest = this.zoomRequest = (this.zoomRequest || 0) + 1;
      const previewSrc = trigger.querySelector('img')?.currentSrc || part.zoom_image;
      img.style.visibility = 'hidden';
      img.onload = () => { img.style.visibility = 'visible'; };
      img.loading = 'eager';
      img.removeAttribute('srcset');
      img.src = previewSrc;
      const fullImage = new Image();
      fullImage.onload = () => {
        if (this.zoomRequest === zoomRequest && this.imageDialog.open) img.src = part.zoom_image;
      };
      fullImage.src = part.zoom_image;
      img.alt = part.title;
      this.imageDialog.querySelector('#wb-image-caption').textContent = part.title;
      this.imageDialog.querySelector('[data-zoom-note]').hidden = trigger.dataset.aiWinter !== 'true';
      this.zoomFocus = 0.5;
      this.setImageZoom(false);
      this.zoomTrigger = trigger;
      this.imageDialog.showModal();
      this.imageDialog.querySelector('[data-zoom-close]').focus({preventScroll:true});
      this.animateIn(this.imageDialog.querySelector('.wb-image-dialog-inner'), 0, 5, 220);
    }
    setImageZoom(zoomed) {
      this.imageDialog.classList.toggle('is-zoomed', zoomed);
      this.imageDialog.querySelector('[data-zoom-toggle]').setAttribute('aria-pressed', String(zoomed));
      this.imageDialog.querySelector('[data-zoom-in]').hidden = zoomed;
      this.imageDialog.querySelector('[data-zoom-out]').hidden = !zoomed;
      const stage = this.imageDialog.querySelector('.wb-zoom-stage');
      stage.scrollTop = 0;
      stage.scrollLeft = zoomed ? Math.max(0, stage.scrollWidth * this.zoomFocus - stage.clientWidth / 2) : 0;
    }
    toggleImageZoom() {
      this.setImageZoom(!this.imageDialog.classList.contains('is-zoomed'));
    }
    available(part, size) { return this.data.colors[this.color].parts[part].variants.some(v => v.size === size && v.available); }
    renderPricing() {
      const variants = this.data.colors[this.color].variants;
      const priced = variants.find(variant => variant.options[0] === this.selection.leggings && variant.options[1] === this.selection.zip) || variants[0];
      if (!priced) return;
      const percent = priced.compare > priced.price ? Math.round((priced.compare - priced.price) / priced.compare * 100) : 0;
      this.priceText = priced.priceText;
      const format = text => text.replaceAll('__WB_PRICE__', priced.priceText).replaceAll('__WB_COMPARE__', priced.compareText).replaceAll('__WB_PERCENT__', String(percent));
      this.querySelectorAll('[data-wb-price]').forEach(el => { el.textContent = priced.priceText; });
      this.querySelectorAll('[data-wb-compare]').forEach(el => { el.textContent = priced.compareText; });
      this.querySelectorAll('[data-wb-percent]').forEach(el => { el.textContent = '−' + percent; });
      this.querySelectorAll('[data-wb-copy]').forEach(el => { el.textContent = format(this.data.pricingText[el.dataset.wbCopy]); });
      for (const number of [1, 5]) this.querySelector('[data-wb-faq="' + number + '"]').textContent = format(this.data.pricingText['faq_' + number + '_a']);
      this.querySelectorAll('.wb-discount-badge').forEach(el => {
        el.hidden = !percent;
        el.setAttribute('aria-label', format(this.data.pricingText.saving));
        el.title = format(this.data.pricingText.saving);
      });
      this.addLabel = format(this.t.add);
    }
    render() {
      this.renderPricing();
      for (const part of ['leggings','zip']) this.querySelectorAll(`[name="${part}"]`).forEach(input => {
        input.disabled = !this.available(part, input.value);
        input.setAttribute('aria-label', input.value + (input.disabled ? ' – ' + this.t.unavailable : ''));
        input.closest('label').title = input.disabled ? this.t.unavailable : input.value;
      });
      this.querySelectorAll('[data-selected-size]').forEach(el => {
        const part = el.dataset.selectedSize;
        const size = this.selection[part];
        const unavailable = !!size && !this.available(part, size);
        el.textContent = size || this.t.sizeMissing;
        el.classList.toggle('is-unavailable', unavailable);
        el.title = unavailable ? this.t.unavailable : '';
      });
      const chosen = !!this.selection.leggings && !!this.selection.zip;
      const partsAvailable = this.available('socks','37-43') && this.available('headband','Default Title');
      const valid = chosen && this.available('leggings',this.selection.leggings) && this.available('zip',this.selection.zip) && partsAvailable;
      this.valid = valid;
      this.add.disabled = !valid || this.busy;
      this.cartButton.disabled = !valid || this.busy;
      this.add.textContent = !chosen ? this.t.select : !valid ? this.t.unavailable : this.addLabel;
      this.querySelector('[data-selection]').textContent = this.data.colors[this.color].name + ' · ' + (chosen ? `Chacco ${this.selection.leggings} · ZIP ${this.selection.zip}` : this.t.select);
      this.message.textContent = chosen && !valid ? this.t.combination : '';
    }
    async submit(destination = 'checkout') {
      if (!this.valid || this.busy) return;
      if (this.dataset.preview === 'true') { this.message.textContent = this.t.preview; return; }
      this.busy = true; this.add.disabled = true; this.cartButton.disabled = true; this.add.textContent = this.t.loading; this.message.textContent = '';
      try {
        const root = this.dataset.root;
        const selectedColor = this.color;
        const selectedSizes = {...this.selection};
        const response = await fetch(root + 'products/' + encodeURIComponent(this.data.colors[selectedColor].handle) + '.js', {credentials:'same-origin'});
        if (!response.ok) throw new Error(this.t.notLive);
        const product = await response.json();
        const variant = product.variants.find(v => v.options[0] === selectedSizes.leggings && v.options[1] === selectedSizes.zip);
        if (selectedColor !== this.color || selectedSizes.leggings !== this.selection.leggings || selectedSizes.zip !== this.selection.zip) throw new Error(this.t.select);
        if (!variant || !variant.available) throw new Error(this.t.stockChanged);
        const added = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});
        const result = await added.json();
        if (!added.ok) throw new Error(result.description || this.t.error);
        window.location.assign(root + (destination === 'cart' ? 'cart' : 'checkout'));
      } catch(error) { this.message.textContent = error.message || this.t.error; }
      finally { this.busy = false; this.add.disabled = !this.valid; this.cartButton.disabled = !this.valid; this.add.textContent = this.addLabel; }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
